import { IconName } from '@shared/components/core/images/IconMap';
import { AllLicenseTypes, UserAllLicenseModel } from '@shared/models/organizations/AllLicenseTypes';
import OrganizationModelLicense from '@shared/models/organizations/OrganizationModelLicenses';

// Accepts anything carrying license access flags (OrganizationModel, ProductModel,
// LicenseKeyCheckResponse, UserLicenseAccessModel, trials, …) — all extend OrganizationModelLicense.
export const getLicenseType = (organization: OrganizationModelLicense | null | undefined): AllLicenseTypes => {
    if (!organization) {
        return 'personal';
    }
    // professional licenses
    if (organization.isEmployeeAccess) {
        return 'isEmployeeAccess';
    }
    if (organization.isDeveloperAccess) {
        return 'isDeveloperAccess';
    }
    if (organization.isStudentAccess) {
        return 'isStudentAccess';
    }
    if (organization.isPlusAccess) {
        return 'isPlusAccess';
    }

    // default placeholder, in case it is unrecognized license type
    return 'isEmployeeAccess';
};

export const ICON_BY_TYPE: Record<keyof UserAllLicenseModel, IconName> = {
    personal: 'basic_plan',
    isPlusAccess: 'plus_plan',
    isEmployeeAccess: 'pro_plan',
    isDeveloperAccess: 'dev_plan',
    isStudentAccess: 'edu_plan',
};

export const LICENSE_TITLE_KEY = {
    personal: 'common:billing.personal.title',
    isPlusAccess: 'common:billing.isPlusAccess.title',
    isEmployeeAccess: 'common:billing.isEmployeeAccess.title',
    isStudentAccess: 'common:billing.isStudentAccess.title',
    isDeveloperAccess: 'common:billing.isDeveloperAccess.title',
} as const satisfies Record<AllLicenseTypes, string>;
